<template>
    <!-- FOOTER -->
    <transition-group name="list">

		 <div class="container-fluid" id="bottomCTA" key="footer" v-bind:key="0">
            <div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
            <div class="footer-left-246">
              <a href="https://www.kingscamps.org/kings-camps-policies/" target="_blank">
                Camp Policies
              </a>
            </div>
            <div class="footer-left-main">
						  <p v-html="locale.text_copyright"></p>
						  <a v-for="link in $root.config.footer_nav_links" :href="link.location" target="_blank" v-html="link.title"></a>
            </div>
					</div>

					<div class="col-xs-12 col-sm-5 col-md-5 col-lg-5">
						<div class="contact-meta">
							<div class="phone-icon hidden-xs">
							</div>

							<div class="phone-number">
								<span class="hidden-md hidden-lg hidden-sm" v-html="locale.text_telephone_number_prefix"></span>
								<span class="hidden-xs" v-html="locale.text_telephone_number_prefix"></span>
                <a class="footer-phone-246" :href="'tel:0151 433 6941'"><b v-html="'0151 433 6941'"></b></a>
                <a class="footer-phone-main" :href="'tel:'+$root.config.kings_phone_number"><b v-html="$root.config.kings_phone_number"></b></a>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>

    </transition-group>
</template>

<script>
    export default {
        computed: {
            locale: function () {
                return this.$root.locale.miscellaneous.footer;
			}
		}
    }
</script>



// WEBPACK FOOTER //
// Footer.vue?dff49ae0